import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IEmails } from '../../../reportsContext/reportsState/reportsContext';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import AddEmailBtn from './AddEmailBtn';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './CopyEmailsBlock.module.scss';

interface ICopyEmailsBlock {
	addCopyEmails: (value: IEmails) => void;
	changeCopyEmails(emailId: string, email: string): void;
	deleteCopyEmails(emailId: string): void;
	copyEmails: IEmails[];
}

const CopyEmailsBlock: React.FC<ICopyEmailsBlock> = ({
	addCopyEmails,
	changeCopyEmails,
	deleteCopyEmails,
	copyEmails,
}) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			{
				type: 'email',
				message: t('invalidEmail'),
			},
		],
		[t],
	);

	const copyEmailsList = useMemo(() => {
		return copyEmails.map((el, i) => {
			const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
				e.target.maxLength = 128;
				changeCopyEmails(el.id, e.target.value);
			};

			return (
				<div className={style.inputWrapper} key={el.id}>
					<FormInput
						testId={`CopyEmailField-${el.id}`}
						name={el.id}
						label="emailCopyLabel"
						getValueFromEvent={handleChange}
						validationRules={validationRules}
					/>
					{i !== 0 && (
						<svg className={style.deleteIcon} onClick={() => deleteCopyEmails(el.id)}>
							<use xlinkHref={`${breadcrumbs}#close`} />
						</svg>
					)}
				</div>
			);
		});
	}, [changeCopyEmails, deleteCopyEmails, copyEmails, validationRules]);

	return (
		<div className={style.container}>
			<div className={style.inputsContainer}>{copyEmailsList}</div>
			<AddEmailBtn addCopyEmails={addCopyEmails} />
		</div>
	);
};

export default React.memo(CopyEmailsBlock);
